module.exports = __webpack_public_path__ + "static/media/Van-Masters.e8b211c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/Van-Masters.png
// module id = 341
// module chunks = 0